import { useMemo } from 'react';
import { AssetFactory, type Asset, type AssetDTO } from 'app/domain';

// Single, stateless construction path. Memoized per DTO reference: the
// factory (and its predicate closures) runs once per asset, not per render —
// callers must pass the stable store reference, never a pre-spread clone.
//
// This is the interim seam. When search results move to React Query, the
// `fromDTO` call relocates into the query's `select` and this hook is
// deleted; components already consume `Asset`, so their contracts don't change.
const assetFactory = new AssetFactory();

const useAsset = (dto: AssetDTO): Asset =>
  useMemo(() => assetFactory.fromDTO(dto), [dto]);

export default useAsset;
